<template>
  <section>
    <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

    <hr/>

    <b-table :data="messages"

             hoverable
             bordered

             narrowed
    >
      <b-table-column field="name" label="Статус" centered>
        <template v-slot="props">
          {{ translate(props.row.name) }}
        </template>
      </b-table-column>

      <b-table-column field="description" label="Сообщение" centered>
        <template v-slot="props">
          <div v-html="formatText(props.row.text)"></div>
        </template>
      </b-table-column>

      <b-table-column field="description" label="Активность" centered>
        <template v-slot="props">
          <b-tag v-if="props.row.enabled" type="is-success">Включено</b-tag>
          <b-tag v-else type="is-danger">Отключено</b-tag>
        </template>
      </b-table-column>

      <b-table-column field="edit" label="Действия" centered>
        <template v-slot="props">
          <div class="buttons">
            <b-button type="is-primary" icon-right="pencil-outline"
                      tag="router-link" :to="{ name: 'DeliveryNotificationMessagesEdit', params: {id: props.row.id} }"
            />
            <b-button v-if="props.row.enabled"
                      type="is-primary" icon-right="bell-off-outline"
                      @click="disable(props.row.id)"
            />
            <b-button v-else
                      type="is-primary" icon-right="bell-outline"
                      @click="enable(props.row.id)"
            />
          </div>
        </template>
      </b-table-column>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                  icon="emoticon-frown-outline"
                  size="is-large"
              />
            </p>
            <p>Данные отсутствуют</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import {translate} from '@/helper/deliveryStatusTranslator';
import deliveryNotificationMessagesRepository from '../../repository/deliveryNotificationMessagesRepository';

export default {
  data () {
    return {
      loading: false,
      messages: [],
    };
  },
  methods: {
    translate,
    fetchData () {
      this.loading = true;

      return deliveryNotificationMessagesRepository.list()
      .then(({data}) => {
        this.messages = data;
      })
      .catch(() => this.$buefy.toast.open({message: 'Ошибка при загрузке', type: 'is-danger'}))
      .finally(() => {
        this.loading = false;
      });
    },
    enable (id) {
      deliveryNotificationMessagesRepository.enable(id)
      .then(() => this.fetchData());
    },
    disable (id) {
      deliveryNotificationMessagesRepository.disable(id)
      .then(() => this.fetchData());
    },
    formatText (text) {
      return text.replace(/\r?\n/g, '<br />');
    },
  },
  mounted () {
    this.fetchData();
  },
};
</script>

<style scoped>

</style>
